import {actions} from 'react-fields'
import user from "../../components/validators/user";

class UsersApi {

    static getUsers(page=1, options={}) {
        let filter = options.filter || {};
        let params = {page: page};
        if(filter.user_status) {params.user_status = filter.user_status}
        if (filter.test_status) {
            params.test_statuses = filter.test_status === 'custom' ? filter.custom_statuses : filter.test_status;
        }
        if (options.per_page) {params.per_page = options.per_page}
        if (options.sort) { params.sort = options.sort}
        if (options.search_q) { params.q = options.search_q}
        const url = `/group/api/users?${actions.paramsToURI(params)}`;

        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static deleteUser(userId){
        const url = `/group/api/users/${userId}`;
        return fetch(actions.deleteRequest(url)).then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static resetUserTest(userId,testId) {
        const url = `/group/api/users/${userId}/reset_test/${testId}`;

        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }

    static addMoreRetakes(userId) {
        const url = `/group/api/users/${userId}/add_retakes`;
        return fetch(actions.getData(url))
            .then(actions.status)
            .then(actions.json)
            .then(function(data) {
                return data;
            })
    }


}

export default UsersApi;